// DesignContentPage4.jsx
import React, { useState, useEffect } from "react";
import {
  TextField,
  Typography,
  Box,
  Grid,
  FormControlLabel,
  Switch,
  MenuItem,
  Button
} from '@mui/material';
import { useStudio } from '../../Context/StudioContext';
import { formatTimeRange, format12Hour } from "..//../utils/FormatTime";
import { getTranslations } from "..//../utils/CardTranslations";

const buttonStyle = {
  textTransform: "none",
  borderColor: "black",
  backgroundColor: "#242424",
  borderRadius: "50px",
  fontSize: "12px",
  color: "white",
  px: "20px",
  py: "7px",
  "&:hover": {
    boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2)',
    color: "white",
    transition: "0.4s",
  },
};

const DesignContentPage5 = ({ data }) => {

  const [selectedSlot, setSelectedSlot] = useState("");
  const [attendant, setAttendant] = useState("");
  const [guestCount, setGuestCount] = useState("1");
  const [name, setName] = useState("");
  const [guestWish, setGuestWish] = useState("");
  const t = getTranslations(data.language);


  // Guest limit: RSVP fallback OR slot-based
  const guestLimit = data.showSlotTime
    ? Number(selectedSlot?.guestPerPax || 1)
    : Number(data.guestPerPax || 1);

  const handleSubmit = () => {
    // In preview mode, we just log (no submission)
    console.log("Preview submit:", { name, attendant, guestCount, guestWish, selectedSlot });
  };

  const handleAttendantChange = (value) => {
    setAttendant(value);

    if (value === "notAttend") {
      // Clear and remove values when user is not attending
      setGuestCount("");
      setSelectedSlot(null);
    }
  };

  useEffect(() => {
    // if slotTimes changed (like after switching type), clear selection
    if (!data.showSlotTime || (data.slotTimes || []).length === 0) {
      setSelectedSlot(null);
    }
  }, [data.showSlotTime, data.slotTimes]);

  return (<div style={{ padding: '20px', fontFamily: data.fontStyle, textAlign: 'start' }}>

    <Box sx={{ mt: 0, p: 2, border: '1px solid #ddd', borderRadius: '20px', background: '#fff' }}>

      <Grid>

        {(data.showRSVP || data.showSlotTime) && (

          <div className="radio-toggle-group">
            <label
              className={`radio-toggle-attendant ${attendant === 'attend' ? 'attend-selected' : ''}`}
            >
              <input
                type="radio"
                name="attendant"
                value="attend"
                checked={attendant === 'attend'}
                onChange={() => handleAttendantChange("attend")}

              />
              {t.rsvpAttend}
            </label>

            <label
              className={`radio-toggle-attendant ${attendant === 'notAttend' ? 'notAttend-selected' : ''}`}
            >
              <input
                type="radio"
                name="attendant"
                value="notAttend"
                checked={attendant === 'notAttend'}
                onChange={() => handleAttendantChange("notAttend")}

              />
              {t.rsvpNotAttend}
            </label>
          </div>

        )}


      </Grid>

      <TextField
        label={t.rsvpNameLabel}
        fullWidth
        size="small"
        margin="normal"
        onChange={(e) => setName(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "30px", // Change this value
          },
          '& .MuiInputBase-input': {
            fontSize: '12px',
            padding: "10px 14px"
          }
        }}
      />

      {(data.showRSVP || data.showSlotTime) && (

        < TextField
          select
          label={t.rsvpGuestCountLabel}
          fullWidth
          size="small"
          margin="normal"
          defaultValue="1"
          onChange={(e) => setGuestCount(e.target.value)}
          disabled={attendant === 'notAttend'}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "30px",
            },
            '& .MuiInputBase-input': {
              fontSize: '12px'
            }
          }}
        >
          {[...Array(guestLimit)].map((_, i) => (
            <MenuItem key={i} value={i + 1} sx={{ fontSize: '12px' }}>
              {i + 1} {t.rsvpGuestUnit}
            </MenuItem>
          ))}
        </TextField>
      )}


      <TextField
        label={t.rsvpWishLabel}
        fullWidth
        multiline
        minRows={2}
        size="small"
        margin="normal"
        onChange={(e) => setGuestWish(e.target.value)}
        InputLabelProps={{ shrink: true }}

        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "15px", // Change this value
          },
          '& .MuiInputBase-input': {
            fontSize: '12px',
            gap: 0
          }
        }}
      />

      {/* If SlotTime ON → add dropdown */}
      {data.showSlotTime && (
        <TextField
          select
          label={t.rsvpSlotLabel}
          fullWidth
          size="small"
          margin="normal"
          disabled={attendant === 'notAttend'}
          value={selectedSlot?.slotTimeStart || ""}
          onChange={(e) => {
            const slot = (data.slotTimes || []).find(
              (s) => s.slotTimeStart === e.target.value
            );
            setSelectedSlot(slot || null);
          }}
          InputLabelProps={{ shrink: true }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "30px",
            },
            '& .MuiInputBase-input': {
              fontSize: '12px'
            }
          }}
        >
          {(data.slotTimes || []).map((slot, idx) => (
            <MenuItem key={idx} value={slot.slotTimeStart} sx={{ fontSize: '12px' }}>
              {format12Hour(slot.slotTimeStart)} - {format12Hour(slot.slotTimeEnd)} ({slot.label})
            </MenuItem>
          ))}
        </TextField>
      )}


      <Box sx={{ display: 'grid', gap: 1, mt: 5 }}>
        <Button variant="outlined" sx={{...buttonStyle, backgroundColor: data.themeColour || "#242424", borderColor: data.themeColour || "#242424"}} onClick={handleSubmit}>{t.rsvpSubmit}</Button>

      </Box>

    </Box>
  </div >
  )
};

export default DesignContentPage5;
